{
    "base": "vs-dark",
    "inherit": true,
    "rules": [
      {
        "token": "comment",
        "foreground": "8C9BAB"
      },
	  {
        "token": "keyword",
        "foreground": "FD9891"
      },
	  {
		"token": "string",
		"foreground": "FEC195"
	  },
	  {
		"token": "number",
		"foreground": "85B8FF"
	  },
	  {
		"token": "identifier",
		"foreground": "B6C2CF"
	  },
	  {
		"token": "keyword.directive",
		"foreground": "B6C2CF"
	  },
	  {
		"token": "string.include.identifier",
		"foreground": "B6C2CF"
	  },
	  {
		"token": "tag",
		"foreground": "579DFF"
	  },
	  {
		"token": "attribute.value",
		"foreground": "7EE2B8"
	  },
	  {
		"token": "attribute.name",
		"foreground": "7EE2B8"
	  },
	  {
		"token": "attribute.value.hex.css",
		"foreground": "FEC195"
	  },
	  {
		"token": "attribute.value.number.css",
		"foreground": "85B8FF"
	  },
	  {
		"token": "attribute.value.unit.css",
		"foreground": "85B8FF"
	  },
	  {
		"token": "metatag.html",
		"foreground": "B6C2CF"
	  },
	  {
		"token": "metatag.content.html",
		"foreground": "B6C2CF"
	  },
	  {
		"token": "delimiter.html",
		"foreground": "B6C2CF"
	  },
	  {
		"token": "attribute.value.html",
		"foreground": "FEC195"
	  },
	  {
		"token": "string.key.json",
		"foreground": "7EE2B8"
	  },
	  {
        "token": "metatag.php",
        "foreground": "FD9891",
		"fontStyle": ""
      },
	  {
        "token": "variable",
        "foreground": "CCE0FF"
      },
	  {
		"token": "variable.predefined",
		"foreground": "B6C2CF"
	  },
	  {
		"token": "operator.sql",
		"foreground": "B6C2CF"
	  },
	  {
		"token": "string.sql",
		"foreground": "FEC195"
	  },
	  {
		"token": "predefined.sql",
		"foreground": "7EE2B8"
	  },
	  {
		"token": "type.identifier.swift",
		"foreground": "7EE2B8"
	  },
      {
        "token": "entity.name.function",
        "foreground": "7EE2B8"
      },
      {
        "token": "entity.name.type.class",
        "foreground": "7EE2B8"
      },
      {
        "token": "storage.type.function",
        "foreground": "FD9891"
      },
      {
        "token": "storage.type.class",
        "foreground": "FD9891"
      },
      {
        "token": "constant.language",
        "foreground": "FD9891"
      }
    ],
    "colors": {
      "editor.background": "#101214",
      "editorCursor.foreground": "#B6C2CF"
    }
}